jQuery(function() {
    jQuery('.doctor-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: false,
        cssEase: 'linear',
        arrows: false,
        dots: true,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });
    var content = jQuery('.main-content');

   

    // MOBILE BOTTOM BAR FUNCTIONS
    var bottom_bar = jQuery('.bottom-bar'),
        offset = 300,
        scrolling = false,
        content = jQuery('.main-content');
    if (bottom_bar) {
        window.addEventListener("scroll", function(event) {
            if (!scrolling) {
                scrolling = true;
                (!window.requestAnimationFrame) ? setTimeout(checkBackToTop, 250): window.requestAnimationFrame(checkBackToTop);
            }
        });
    }

     // CHECK DISTANCE FROM TOP OF PAGE
    function checkBackToTop() {
        var windowTop = window.scrollY || document.documentElement.scrollTop;
        (windowTop > 150) ? bottom_bar.addClass('fs-is-visible'): bottom_bar.removeClass('fs-is-visible');
        (windowTop > 150) ? content.addClass('sticked'): content.removeClass('sticked');
        scrolling = false;
    }







    // SEARCH FORM OVERLAY
    var search = jQuery('#fs-search');
    var searchText = jQuery('#search-content');
    var searchInput = jQuery('.search-text');

    function showSearch() {
        search.addClass('fs-search--show');
        search.addClass('a-fadeIn');
        searchText.addClass('a-fadeUp');
        searchInput.focus();
        jQuery('body').addClass('u-overflow-hidden');
    }

    function hideSearch() {
        searchText.removeClass('a-fadeUp');
        searchText.addClass('search-text--hide');
        search.removeClass('a-fadeIn');
        search.addClass('a-fadeOut');
  
        setTimeout(function(){
            search.removeClass('fs-search--show');
            search.removeClass('a-fadeOut');
            searchText.removeClass('search-text--hide');
            jQuery('body').removeClass('u-overflow-hidden');
        }, 300);
    }


    jQuery( "body" ).on( "click", ".search-form-button", function() {
        showSearch();
    });

    jQuery( ".fs-search" ).on( "click", ".hamburger-icon", function() {
        hideSearch();
    });

   


});





jQuery(document).on('click', '.sscroll', function(event) {
    event.preventDefault();
    jQuery('html, body').animate({
        scrollTop: jQuery(jQuery.attr(this, 'href')).offset().top - 60
    }, 500);
});